import './index.css'
import * as React from 'react'
type Props = {
  importantUpdateAvailable?: boolean
}
export default class UpdateInformer extends React.Component<Props> {
  _forceReload: () => void = () => {
    // @ts-expect-error
    location.reload(true)
  }

  render(): null | React.ReactElement<'div'> {
    if (!this.props.importantUpdateAvailable) return null
    return (
      <div className="InformerMessageContainer">
        <div className="InformerMessageContainer_Content">
          DISCO has been updated. Please reload to see the latest, greatest
          version.
          <br />
          (Finish any uploads first, and we&#39;ll save your work.)
        </div>
        <button
          className="InformerMessageContainer_RefreshButton"
          onClick={this._forceReload}
        >
          Reload
        </button>
      </div>
    )
  }
}
